import { atom, selectorFamily } from 'recoil';
import { PlanMembershipItem } from 'modules/layout/types/planMembershipItem';
import { SubscriptionProduct } from 'generated-graphql/types';

export const planMembershipAtom = atom<PlanMembershipItem[]>({
  key: 'planMembershipAtom',
  default: undefined
});

export const checkHasSubscriptionPlan = selectorFamily<
  boolean,
  SubscriptionProduct
>({
  key: 'checkOrganizationHasPlan',
  get:
    (product) =>
    ({ get }) => {
      const planMemberships = get(planMembershipAtom);
      if (!planMemberships) return false;

      const planMembership = planMemberships.find(
        (pm) => pm.product === product
      );

      if (!planMembership) return false;

      switch (product) {
        case SubscriptionProduct.PoppScoring:
          return !!(
            planMembership?.scoringLimit && planMembership?.scoringLimit > 0
          );
        case SubscriptionProduct.PoppConversations:
          return !!(
            planMembership?.messagesLimit && planMembership?.messagesLimit > 0
          );
        default:
          return false;
      }
    }
});

export const isProductLimitReachedSelector = selectorFamily<
  boolean,
  SubscriptionProduct
>({
  key: 'isProductLimitReachedSelector',
  get:
    (product) =>
    ({ get }) => {
      const planMemberships = get(planMembershipAtom);
      if (!planMemberships) return true;

      const planMembership = planMemberships.find(
        (pm) => pm.product === product
      );

      if (!planMembership) {
        return true;
      }

      if (product === SubscriptionProduct.PoppScoring) {
        return !!(
          (planMembership.scoringUsage ?? 0) >=
          (planMembership.scoringLimit ?? 0)
        );
      }

      if (product === SubscriptionProduct.PoppConversations) {
        return !!(
          (planMembership.messagesUsage ?? 0) >=
          (planMembership.messagesLimit ?? 0)
        );
      }

      return true;
    }
});
